import React from 'react';
import {Button, TextField, Select, MenuItem} from '@material-ui/core';
import LabPartner from '@pluto/lab-partner';

import AccountStatusSelector from '@pluto/account-status';
import ContentPartners from '@pluto/content-partners';

import {object, bool, string, func} from 'prop-types';
import PollingTypeSelect from '../PollingTypeSelect/PollingTypeSelectContainer';
import MrssAdditionalFields from '../MrssAdditionalFields/MrssAdditionalFieldsContainer';
import ConfigPublishedDate from '../ConfigPublishedDate/ConfigPublishedDateContainer';

export default function IngestConfig(props: any) {
    const {
        isValidDate,
        qcRequiredField,
        ingestTypeField,
        deliveryRequiredField,
        feedNameField,
        isPublishedDateShown,
        publishedDateField,
        contentPartnerField,
        isMrssAdditionalFieldsShown,
        ratingField,
        categoryField,
        teritoriesField,
        languageField,
        pollingIntervalTypeField,
        pollingIntervalValueField,
        pollingIntervalType,
        urlField,
        authenticationRequiredField,
        passwordField,
        userNameField,
        statusField,
        onSaveHandler,
        onPushRouteToHistory,
        rightTypesField,
        captionsRequiredField,
        copyrightHolderField,
        copyrightYearField,
        feedsLimitField,
        valid,
        onPollingIntervalTypeChange,
        labPartnerField,
        isApiAdditionalFieldsShown,
        isDropFolderAdditionalFieldsShown
    } = props;

    return (
        <>
            <div className="new-ingest-form">
                <div className="new-ingest-form__field">
                    <div className="new-ingest-form__field-label">Ingest Feed Name *</div>
                    <TextField
                        onChange={feedNameField.input.onChange}
                        value={feedNameField.input.value}
                        variant="outlined"
                        error={feedNameField.meta.error}
                    />
                </div>
                <div className="new-ingest-form__field">
                    <div className="new-ingest-form__field-label">Content Partner *</div>
                    <ContentPartners
                        onChange={contentPartnerField.input.onChange}
                        value={contentPartnerField.input.value}
                        variant="outlined"
                    />
                </div>
                <div className="new-ingest-form__field">
                    <div className="new-ingest-form__field-label">Ingest Type *</div>
                    <Select
                        onChange={ingestTypeField.input.onChange}
                        value={ingestTypeField.input.value}
                        variant="outlined"
                    >
                        <MenuItem value="API">API</MenuItem>
                        <MenuItem value="DROP_FOLDER">DROP FOLDER</MenuItem>
                        <MenuItem value="MRSS">MRSS</MenuItem>
                    </Select>
                </div>
                {isDropFolderAdditionalFieldsShown && (
                    <div className="drop-folder-additional-fields">
                        <div className="new-ingest-form__field drop-folder-additional-fields__lab-partner">
                            <div className="new-ingest-form__field-label">
                                Lab partner *
                            </div>
                            <LabPartner labPartnerField={labPartnerField}/>
                        </div>
                    </div>
                )}
                {isApiAdditionalFieldsShown && (
                    <div className="api-additional-fields">
                        <div className="new-ingest-form__field api-additional-fields__lab-partner">
                            <div className="new-ingest-form__field-label">
                                Lab partner *
                            </div>
                            <LabPartner labPartnerField={labPartnerField}/>
                        </div>
                        <div className="api-additional-fields__polling">
                            <div className="new-ingest-form__field new-ingest-form__field_small">
                                <div className="new-ingest-form__field-label new-ingest-form__field-label_polling">
                                    Polling Interval *
                                </div>
                                <Select
                                    onChange={onPollingIntervalTypeChange}
                                    value={pollingIntervalTypeField.input.value}
                                    variant="outlined"
                                >
                                    <MenuItem value="EVERY">Every</MenuItem>
                                    <MenuItem value="DAILY">Daily</MenuItem>
                                    <MenuItem value="TEST">Test</MenuItem>
                                </Select>
                            </div>
                            <div className="new-ingest-form__field">
                                <PollingTypeSelect
                                    isValidDate={isValidDate}
                                    pollingIntervalValueField={pollingIntervalValueField}
                                    pollingIntervalType={pollingIntervalType}
                                    feedsLimitField={feedsLimitField}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <MrssAdditionalFields
                    authenticationRequiredField={authenticationRequiredField}
                    passwordField={passwordField}
                    userNameField={userNameField}
                    pollingIntervalValueField={pollingIntervalValueField}
                    onPollingIntervalTypeChange={onPollingIntervalTypeChange}
                    pollingIntervalTypeField={pollingIntervalTypeField}
                    isValidDate={isValidDate}
                    pollingIntervalType={pollingIntervalType}
                    feedsLimitField={feedsLimitField}
                    isShown={isMrssAdditionalFieldsShown}
                    ratingField={ratingField}
                    categoryField={categoryField}
                    languageField={languageField}
                    teritoriesField={teritoriesField}
                    rightTypesField={rightTypesField}
                    captionsRequiredField={captionsRequiredField}
                    copyrightHolderField={copyrightHolderField}
                    copyrightYearField={copyrightYearField}
                />
                <div className="new-ingest-form__field new-ingest-form__field_big">
                    <div className="new-ingest-form__field-label new-ingest-form__field-label_url">
                        URL *
                    </div>
                    <TextField
                        onChange={urlField.input.onChange}
                        value={urlField.input.value}
                        variant="outlined"
                    />
                </div>
                <div className="new-ingest-form__requiresqc-wrapper">
                    <div className="new-ingest-form__field new-ingest-form__field_small">
                        <div className="new-ingest-form__field-label new-ingest-form__field-label_requiresqc">
                            Requires QC
                        </div>
                        <Select
                            onChange={qcRequiredField.input.onChange}
                            value={qcRequiredField.input.value}
                            variant="outlined"
                        >
                            {/* @ts-expect-error ts-migrate(2769) FIXME: Type 'false' is not assignable to type 'string | n... Remove this comment to see the full error message */}
                            <MenuItem value={false}>No</MenuItem>
                            {/* @ts-expect-error ts-migrate(2769) FIXME: Type 'true' is not assignable to type 'string | nu... Remove this comment to see the full error message */}
                            <MenuItem value>Yes</MenuItem>
                        </Select>
                    </div>
                </div>
                {!qcRequiredField.input.value && (
                    <div className="new-ingest-form__delivery-required-wrapper">
                        <div className="new-ingest-form__field new-ingest-form__field_small">
                            <div className="new-ingest-form__field-label new-ingest-form__field-label_delivery-required">
                                Auto delivery to CMS
                            </div>
                            <Select
                                onChange={deliveryRequiredField.input.onChange}
                                value={deliveryRequiredField.input.value}
                                variant="outlined"
                            >
                                {/* @ts-expect-error ts-migrate(2769) FIXME: Type 'false' is not assignable to type 'string | n... Remove this comment to see the full error message */}
                                <MenuItem value={false}>No</MenuItem>
                                {/* @ts-expect-error ts-migrate(2769) FIXME: Type 'true' is not assignable to type 'string | nu... Remove this comment to see the full error message */}
                                <MenuItem value>Yes</MenuItem>
                            </Select>
                        </div>
                    </div>
                )}
                <div className="new-ingest-form__status-wrapper">
                    <div className="new-ingest-form__field new-ingest-form__field_small">
                        <div className="new-ingest-form__field-label new-ingest-form__field-label_status">
                            Status
                        </div>
                        <AccountStatusSelector
                            onChange={statusField.input.onChange}
                            value={statusField.input.value}
                            variant="outlined"
                        />
                    </div>
                    <ConfigPublishedDate
                        isValidDate={isValidDate}
                        publishedDateField={publishedDateField}
                        isPublishedDateShown={isPublishedDateShown}
                    />
                </div>
                <div className="new-ingest-form__controls-buttons-wrapper">
                    <Button
                        disabled={!valid}
                        className="new-ingest-form__control-button new-ingest-form__control-button_save"
                        variant="contained"
                        onClick={onSaveHandler}
                    >
                        Save
                    </Button>
                    <Button
                        className="new-ingest-form__control-button new-ingest-form__control-button_cancel"
                        variant="contained"
                        onClick={onPushRouteToHistory}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </>
    );
}

IngestConfig.propTypes = {
    ingestTypeField: object.isRequired,
    qcRequiredField: object.isRequired,
    feedNameField: object.isRequired,
    isPublishedDateShown: bool.isRequired,
    publishedDateField: object.isRequired,
    contentPartnerField: object.isRequired,
    feedTypeField: object.isRequired,
    isMrssAdditionalFieldsShown: bool.isRequired,
    ratingField: object.isRequired,
    categoryField: object.isRequired,
    teritoriesField: object.isRequired,
    languageField: object.isRequired,
    pollingIntervalTypeField: object.isRequired,
    pollingIntervalValueField: object.isRequired,
    pollingIntervalType: string.isRequired,
    urlField: object.isRequired,
    authenticationRequiredField: object.isRequired,
    passwordField: object.isRequired,
    userNameField: object.isRequired,
    statusField: object.isRequired,
    onSaveHandler: func.isRequired,
    onPushRouteToHistory: func.isRequired,
    rightTypesField: object.isRequired,
    captionsRequiredField: object.isRequired,
    copyrightHolderField: object.isRequired,
    copyrightYearField: object.isRequired,
    feedsLimitField: object.isRequired,
    valid: bool.isRequired,
    onPollingIntervalTypeChange: func.isRequired,
    isValidDate: object.isRequired,
    deliveryRequiredField: object.isRequired,
    isApiAdditionalFieldsShown: bool.isRequired,
    isDropFolderAdditionalFieldsShown: bool.isRequired,
    labPartnerField: object.isRequired,
};
